import React from "react";
import { getLogoIcon } from "@/lib/logoLibrary";
import { resolveAsset } from "@/lib/api";

/**
 * Logo en style "icône iPhone" : carré arrondi monochrome.
 * Utilise Font Awesome 6 (CDN chargé dans public/index.html).
 */
export default function LogoDisplay({ type, value, size = 56, alt = "", tone }) {
  const px = `${size}px`;
  const radius = `${Math.round(size * 0.22)}px`;
  const bg = tone || "hsl(var(--primary))";

  const tile = (children) => (
    <div
      className="relative flex items-center justify-center overflow-hidden"
      style={{
        width: px,
        height: px,
        borderRadius: radius,
        background: bg,
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.18), 0 1px 2px rgba(0,0,0,0.1), 0 8px 22px rgba(0,0,0,0.15)",
      }}
    >
      {children}
      <span
        className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0) 55%)" }}
      />
    </div>
  );

  if (type === "icon") {
    const entry = getLogoIcon(value);
    if (entry) {
      return tile(
        <i className={entry.faClass} style={{ color: "#fff", fontSize: size * 0.45 }} aria-hidden="true" />
      );
    }
  }

  if ((type === "upload" || type === "url") && value) {
    const src = type === "upload" ? resolveAsset(value) : value;
    return tile(
      <img
        src={src}
        alt={alt}
        style={{
          width: "60%",
          height: "60%",
          objectFit: "contain",
          filter: "brightness(0) invert(1)",
        }}
      />
    );
  }

  return tile(<i className="fa-solid fa-link" style={{ color: "#fff", fontSize: size * 0.45 }} aria-hidden="true" />);
}
